module.exports = __webpack_public_path__ + "img/2.d5d3e78.png";